import { motion } from "framer-motion";
import { Reveal, Overline } from "@/components/Reveal";
import { CHAPTERS, FORMAZIONE, IMAGES } from "@/lib/data";

const About = () => (
  <section id="chi-sono" data-testid="about-section" className="bg-white py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Overline>01 — Chi Sono</Overline>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#1A2E2A] leading-[1.1]">
              Il Tuo Benessere <span className="italic text-[#489A88]">al Centro</span>
            </h2>
            <p className="mt-7 text-base sm:text-lg leading-relaxed text-[#4A5568] max-w-lg">
              Sono Massoterapista M.C.B. qualificata: i miei trattamenti sono sempre personalizzati perché porto attenzione alla persona nella sua totalità, senza sottovalutare l'aspetto psico-fisico come concausa dei dolori muscolo-articolari. Mi avvalgo oltre che delle mani, lo strumento di lavoro principale, anche di ausili quali coppette, kinesio taping neuromuscolare e I.A.S.T.M. (Instrument Assisted Soft Tissue Mobilization).
            </p>
          </Reveal>

          <div className="mt-12 space-y-0">
            {CHAPTERS.map((ch, i) => (
              <Reveal key={ch.number} delay={i * 0.12}>
                <div className="group flex gap-6 py-7 border-t border-[#E2E8F0] last:border-b" data-testid={`about-chapter-${ch.number}`}>
                  <span className="font-['Outfit'] text-sm font-medium text-[#489A88] pt-1 tracking-widest">{ch.number}</span>
                  <div>
                    <h3 className="font-['Outfit'] text-xl font-medium text-[#1A2E2A] group-hover:text-[#2D6D60] transition-colors duration-300">
                      {ch.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-[#64748B] max-w-md">{ch.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.25}>
            <div className="mt-12 rounded-[1.75rem] bg-[#FAF8F5] border border-[#E2E8F0] p-8" data-testid="formazione-block">
              <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#489A88]">Istruzione e Formazione</p>
              <div className="mt-5">
                {FORMAZIONE.map((f, i) => (
                  <div key={`${f.year}-${f.title}`} className="flex gap-5 py-4 border-t border-[#E2E8F0]/80 first:border-t-0 first:pt-0 last:pb-0" data-testid={`formazione-item-${i}`}>
                    <span className="shrink-0 w-20 font-['Outfit'] text-sm font-semibold text-[#2D6D60] pt-0.5">{f.year}</span>
                    <div>
                      <p className="text-sm font-semibold text-[#1A2E2A]">{f.title}</p>
                      <p className="text-xs text-[#64748B] mt-1 leading-relaxed">{f.detail}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="relative">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-40 h-40 rounded-tl-[3rem] border-t-2 border-l-2 border-[#489A88]/40" aria-hidden="true" />
            <motion.div
              whileHover={{ scale: 0.985 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-[2rem] overflow-hidden shadow-[0_40px_80px_-30px_rgba(26,46,42,0.35)]"
            >
              <img
                src={IMAGES.studio}
                alt="Lo studio privato di massoterapia di Francesca Cicardi a Vanzago"
                className="w-full aspect-[4/5] object-cover"
                data-testid="about-studio-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A2E2A]/50 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 rounded-2xl bg-white/85 backdrop-blur-md px-6 py-4">
                <p className="font-['Outfit'] font-medium text-[#1A2E2A]">Lo Studio</p>
                <p className="text-sm text-[#64748B]">Un ambiente riservato, sanificato e accogliente nel cuore di Vanzago</p>
              </div>
            </motion.div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default About;
